import { framesConstants, authConstants } from '../constants';
import { MessagesActions, EventsActions } from './';
import { FramesApi } from '../services';

export class FramesActions {
    static getAllFrames(eventID) {
        return (dispatch) => {
            dispatch({type: framesConstants.GET_ALL_FRAMES_REQUEST});

            FramesApi.getAllFrames(eventID)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: framesConstants.GET_ALL_FRAMES_SUCCESS, payload: {[eventID]: res.data}});
                        return;
                    }

                    return dispatch({type: framesConstants.GET_ALL_FRAMES_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: framesConstants.GET_ALL_FRAMES_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה בטעינת המסגרות'));
                });
        }
    }

    static uploadFrame (eventID, data) {
        return (dispatch) => {
            dispatch({type: framesConstants.UPLOAD_FRAME_REQUEST});

            var formData = new FormData();

            for(let key in data) {
                formData.append(key, data[key]);
            }

            FramesApi.uploadFrame(eventID, formData)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {                        
                        dispatch(EventsActions.getEventData(eventID)); // get updated event data (with new frame)
                        dispatch({type: framesConstants.UPLOAD_FRAME_SUCCESS, payload: {[eventID]: [res.data]}});
                        // dispatch(MessagesActions.pushSuccess('המסגרת עודכנה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('עדכון המסגרת נכשל אנא נסו שוב...'));
                    return dispatch({type: framesConstants.UPLOAD_FRAME_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: framesConstants.UPLOAD_FRAME_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static updateFrame (eventID, frameID, data) {
        return (dispatch) => {
            dispatch({type: framesConstants.UPDATE_FRAME_REQUEST});

            FramesApi.updateFrame(eventID, frameID, data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: framesConstants.UPDATE_FRAME_SUCCESS, payload: {[eventID]: [res.data]}});
                        // dispatch(MessagesActions.pushSuccess('המסגרת עודכנה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('לא ניתן לעדכן את המסגרת אנא נסו שנית'));
                    return dispatch({type: framesConstants.UPDATE_FRAME_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: framesConstants.UPDATE_FRAME_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static deleteFrame (eventID, frameID) {
        return (dispatch) => {
            dispatch({type: framesConstants.DELETE_FRAME_REQUEST});

            FramesApi.deleteFrame(eventID, frameID)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch(EventsActions.getEventData(eventID)); // get updated event data (without this frame)
                        dispatch({type: framesConstants.DELETE_FRAME_SUCCESS, payload: {eventID: eventID}});
                        // dispatch(MessagesActions.pushSuccess('המסגרת נמחקה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('מחיקת המסגרת נכלשה אנא נסו שוב...'));
                    return dispatch({type: framesConstants.DELETE_FRAME_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: framesConstants.DELETE_FRAME_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }
}




// WEBPACK FOOTER //
// ./src/actions/frames.js